import { dateOf, dateTimeOf, MS_IN, shortDateOf, shortDateTimeOf, SortTypeEnum } from "@repo/helpers";

import { Column, ColumnPath } from "./column";

export class DateColumn<T> extends Column<T> {
	constructor(
		name: string,
		propertyName?: ColumnPath<T>,
		sortBy = SortTypeEnum.none,
		format?: any,
		sortable?: boolean,
	) {
		super(name, propertyName, sortBy, format, sortable);
		this.toString();
	}

	public withDateCalc(calcFunction?: (i: T) => Date) {
		this.clearFormat();
		return this.withFormat(calcFunction).toString();
	}

	public toString() {
		return this.withFormat(dateTimeOf);
	}

	public dateOnly(short = false) {
		return this.withFormat(short ? shortDateOf : dateOf);
	}

	public short() {
		return this.withFormat(shortDateTimeOf);
	}
}

export class LocalDateColumn<T> extends DateColumn<T> {
	constructor(
		name: string,
		propertyName?: ColumnPath<T>,
		sortBy: SortTypeEnum = SortTypeEnum.none,
		format?: any,
		sortable?: boolean,
	) {
		super(name, propertyName, sortBy, format, sortable);
		this.withFormat(this.convertDateToLocal);
		this.toString();
	}

	convertDateToLocal = (d: Date | string) => {
		if (!d) return d;
		const date = typeof d === "string" ? new Date(d) : d;
		return date.toLocaleString() + " UTC";
	};
}

export class OriginalTimezoneDateColumn<T> extends DateColumn<T> {
	constructor(
		name: string,
		propertyName?: ColumnPath<T>,
		sortBy: SortTypeEnum = SortTypeEnum.none,
		f?: any,
		sortable?: boolean,
	) {
		super(name, propertyName, sortBy, f, sortable);
		this.withFormat(this.convertDateToUtc);
		this.toString();
	}

	convertDateToUtc = (d: Date | string) => {
		if (!d) return d;
		const date = typeof d === "string" ? new Date(d) : d;
		const newDate = new Date(date.getTime() + date.getTimezoneOffset() * MS_IN.MINUTE);
		return newDate;
	};
}
